import { render, staticRenderFns } from "./SeoEdit.vue?vue&type=template&id=6d772756&scoped=true"
import script from "./SeoEdit.vue?vue&type=script&lang=js"
export * from "./SeoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d772756",
  null
  
)

export default component.exports